"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import ArrowRight from "~/components/icons/arrow-right-eon";
import JobAdVideo from "~/components/job-page/jobadvideo/jobad-video-eon";
import { env } from "~/setup/env";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function AboutEonGridsolutions(_props) {
  const $ = _c(14);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobad/about-bg.webp)`,
      backgroundSize: "cover"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative aspect-video w-full lg:aspect-auto"><JobAdVideo hideControls={true} playOnLoad={true} thumbnailSrc="images/videos/about-thumbnail.webp" videoUrl="EON_Logo_Staging_Swarm_1920x1080.mp4" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t.jobad_about) {
    t2 = <p className="text-lg lg:text-xl" data-source="lc">{t.jobad_about}</p>;
    $[2] = t.jobad_about;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="mt-2 text-lg lg:text-xl" data-source="text">Als <span className="font-bold">E.ON Grid Solutions</span> sind wir der führende Digitaldienstleister für den Verteilnetz- und Messstellenbetrieb. Wir verbinden über unsere Systemlandschaft die Teilnehmer im Energiesystem – von Bezugs-/ Einspeisekund:innen über Lieferanten bis zum Verteilnetzbetreiber.</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ArrowRight className="h-8 pr-1" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t.jobad_about_button_title) {
    t5 = <p className="border-inherit border-b-2" data-source="lc">{t.jobad_about_button_title}</p>;
    $[6] = t.jobad_about_button_title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t.jobad_about_button_link || $[9] !== t5) {
    t6 = <CustomLink blank={true} className="mt-6 flex items-center border-foreground font-bold text-lg transition-colors duration-300 hover:border-white md:mt-12" href={t.jobad_about_button_link}>{t4}{t5}</CustomLink>;
    $[8] = t.jobad_about_button_link;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <section className="outer-container pointer-fine:bg-fixed py-container print:hidden" id="about" style={t0}><div className="inner-container grid gap-10 bg-white p-10 lg:relative lg:grid-cols-2">{t1}<div><div className="flex h-full flex-col justify-center">{t2}{t3}{t6}</div></div></div></section>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}